import { Component, Input, OnChanges, inject } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { ValidationErrors } from "../models/validation-errros.interface";
import { TelenetIconComponent } from "../../telenet-icons/telenet-icon.component";
import { ValidationErrorBodyPipe } from "../pipes/validation-error-body.pipe";

@Component({
   selector: "my-cloud-validation-errors",
   templateUrl: "./validation-errors.component.html",
   styleUrls: ["./validation-errors.component.scss"],
   imports: [TelenetIconComponent, TranslatePipe, ValidationErrorBodyPipe]
})
export class ValidationErrorsComponent implements OnChanges {
   private translate = inject(TranslateService);

   @Input() public validationErrors: ValidationErrors | undefined;

   public groupedValidationErrors: Array<{
      property: string;
      errors: Array<string>;
   }>;

   public ngOnChanges(): void {
      if (!this.validationErrors || !this.validationErrors.hasErrors) {
         this.groupedValidationErrors = undefined;
         return;
      }

      const grouped = this.groupBy(this.validationErrors.errors, "property");

      this.groupedValidationErrors =
         this.validationErrors.status === 400
            ? Object.keys(grouped).map(key => ({
                 property: key,
                 errors: grouped[key].map((x: { error: string | string[] }) =>
                    this.translate.instant(x.error)
                 )
              }))
            : [{ property: "property", errors: [] }];
   }

   private groupBy(items: any[], key: string): any {
      return items.reduce(
         (
            result: { [x: string]: any[] },
            item: { [x: string]: string | number }
         ) => {
            (result[item[key]] = result[item[key]] || []).push(item);
            return result;
         },
         {}
      );
   }
}
